import { apiPost } from '@/infrastructure/api-client';
import type { ConfirmImportRequest, ConfirmImportResponse } from '@/contracts/export-import';

export function confirmImport(input: ConfirmImportRequest): Promise<ConfirmImportResponse> {
  return apiPost('/api/funnels/import', input);
}
